import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-primary-950 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 py-12 md:grid-cols-4 md:px-6 md:py-16">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              蜜桃成熟时33D
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            本站为影视资讯与观影指导类演示网站，提供《蜜桃成熟时33D》及相关影视作品的剧情介绍、演员资料与观影指南。站内所有影片、演员及相关数据均为虚构演示内容。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">
            <Link to="/movies" className="transition-colors hover:text-primary-300">
              站内导航
            </Link>
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li>
              <Link to="/" className="transition-colors hover:text-primary-300">
                首页
              </Link>
            </li>
            <li>
              <Link to="/movies" className="transition-colors hover:text-primary-300">
                电影分类
              </Link>
            </li>
            <li>
              <Link to="/actors" className="transition-colors hover:text-primary-300">
                演员信息
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-primary-300">
                关于我们
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-background-50">联系我们</h4>
          <ul className="mt-4 space-y-3 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base"></i>
              <span>service@peach33d.example.com</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-base"></i>
              <span>演示站点 · 无实体地址</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-base"></i>
              <span>内容每日更新</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-900/60">
        <div className="mx-auto flex flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 md:flex-row md:px-6">
          <p>© 2026 蜜桃成熟时33D 影视资讯站 · 本站为演示项目，内容均为虚构</p>
          <p>声明：本站不提供任何真实影片播放与下载服务，仅供影视资讯参考。</p>
        </div>
      </div>
    </footer>
  );
}